import { z } from "zod";

/**
 * Situations an approved reply is written for. The agent reads the situation from the step's
 * tool results (packages/agent/src/phrasebook.ts), never from a model.
 */
export const PHRASE_SITUATIONS = [
	"greeting",
	"thanks",
	"found",
	"broad",
	"cheaper",
	"not_found",
	"out_of_stock",
	"age_restricted",
	"added",
	"removed",
	"recipe",
	"escalated",
] as const;
export type PhraseSituation = (typeof PHRASE_SITUATIONS)[number];

export const languagesSchema = z
	.object({
		/** Languages the shopper may write in; the agent answers in theirs. */
		supported: z.array(z.string()).min(1).default(["English"]),
		/** Free-text rules: dialect, register, script conventions, words to avoid. */
		rules: z.string().max(4000).default(""),
		/** Native-approved replies per situation; the ones matching the turn are shown to the model. */
		phrasebook: z
			.array(
				z.object({
					language: z.string().min(1).max(40),
					situation: z.enum(PHRASE_SITUATIONS),
					/** Blank lines survive editing; the agent skips them. */
					replies: z.array(z.string().max(240)).max(12),
				}),
			)
			.max(80)
			.default([]),
	})
	.prefault({});
